import { graphql } from "babel-plugin-relay/macro";
import { Button } from "primereact/button";
import { useLazyLoadQuery, useMutation } from "react-relay";
import { CreateVideoElementButton_CreateVideoElementMutation } from "../../../../../../../../__generated__/CreateVideoElementButton_CreateVideoElementMutation.graphql";
import { CreateVideoElementButton_VimeoSourceQuery } from "../../../../../../../../__generated__/CreateVideoElementButton_VimeoSourceQuery.graphql";

const CREATE_VIDEO_ELEMENT_MUTATION = graphql`
	mutation CreateVideoElementButton_CreateVideoElementMutation(
		$input: CreateVideoElementV2Input!
	) {
		Admin {
			ElearningV2 {
				createVideoElement(input: $input) {
					eLearningContentNode {
						...ContentCard_TreeNodeFragment
					}
				}
			}
		}
	}
`;

const VIMEO_SOURCE_QUERY = graphql`
	query CreateVideoElementButton_VimeoSourceQuery {
		Admin {
			VimeoVideoSource {
				GetDefaultVimeoVideoSource {
					id
				}
			}
		}
	}
`;

interface OwnProps {
	eLearningContentNodeId: string;
}

export const CreateVideoElementButton = ({ eLearningContentNodeId }: OwnProps) => {
	const {
		Admin: {
			VimeoVideoSource: { GetDefaultVimeoVideoSource: vimeoVideoSource },
		},
	} = useLazyLoadQuery<CreateVideoElementButton_VimeoSourceQuery>(
		VIMEO_SOURCE_QUERY,
		{},
		{ fetchPolicy: "network-only" },
	);

	const [createVideoElement, isCreatingVideoElement] =
		useMutation<CreateVideoElementButton_CreateVideoElementMutation>(
			CREATE_VIDEO_ELEMENT_MUTATION,
		);

	return (
		<Button
			className={"mr-2"}
			disabled={isCreatingVideoElement}
			tooltip={"Video-Baustein anlegen"}
			icon="pi pi-video"
			onClick={() => {
				createVideoElement({
					variables: {
						input: {
							title: "Neues Element",
							vimeoId: "",
							eLearningContentNodeId: eLearningContentNodeId,
							vimeoVideoSourceId: vimeoVideoSource?.id!,
						},
					},
				});
			}}
		/>
	);
};
